import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";

export const requestAdvancedProbeTypesAsync = (mac) => {
  const url = getUrl("getAdvanceTabProbeTypes")(mac);
  return trackPromise(Call.get(url));
};

export const requestSlaveListAsync = ({mac, probeId}) => {
  const url = getUrl("getSlaveList")(mac, probeId);
  return trackPromise(Call.get(url));
};

export const updateSlaveAsync = ({mac, probeId}, payload) => {
  const url = getUrl("getSlaveList")(mac, probeId);
  return trackPromise(Call.patch(url, payload));
};
